import React, { Fragment } from "react";
import CreateStore from "../../components/createstore/CreateStore";

import "./createstorepage.scss";

const CreateStorePage = () => {
  return (
    <Fragment>
      <div className="create-store-page-desktop">
        <div className="create-store-container mx-auto">
          <CreateStore />
        </div>
      </div>
    </Fragment>
  );
};

export default CreateStorePage;
